import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY } from '_api/queries/challenge/useGetAllPatientChallengesByID';
import { AddChallengeToPatientPayload } from '_api/types';

export const ADD_CHALLENGE_TO_PATIENT_KEY = 'add-challenge-to-patient';

export const useAddChallengeToPatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, AddChallengeToPatientPayload[]>(
    () => '/challenge/add-patient-challenge-setting',
    'post',
    {},
    {
      mutationKey: [ADD_CHALLENGE_TO_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY],
        });
      },
    },
    (body: AddChallengeToPatientPayload[]) => JSON.stringify(body),
  );
};
